// Select all or unselect all items currently on the page
export const handleSelectAllById = (currentPage, itemsPerPage, lots, selectedLots) => {
  const updatedLots = new Set(selectedLots);

  /**
   * For instance: current page is 1 (the second page), and 50 lots per
   * page, we want to select lots 50-99 If the current page is 0,
   * with 50 lots per page, select lots 0-49
   */
  const minIndex = currentPage * itemsPerPage;

  // check if this is the last page and truncate the number of items per page if true
  let checkedItemsPerPage = itemsPerPage;
  if (minIndex + itemsPerPage > lots.length) {
    checkedItemsPerPage = lots.length % itemsPerPage;
  }

  // For each item in the list get its id and add to the list
  const arrayOfValues = [];
  for (let i = 0; i < checkedItemsPerPage; i += 1) {
    const index = currentPage * itemsPerPage + i;
    arrayOfValues.push({
      lot: (['id'] in lots[index] ? lots[index].id : `${lots[index].lotNumber}${lots[index].lotExt}`),
      deleted: lots[index].deleted || false,
    });
  }

  const numDeletedPerPage = arrayOfValues.reduce((total, value) => (
    value.deleted ? ++total : total), 0);
  const selectedItems = arrayOfValues.filter(value => selectedLots.has(value.lot)).length;

  /**
   * If every item in this array of values is currently in selected lots - the user wants to
   * "unselect" them all
   */
  const allItemsSelected = selectedItems === (checkedItemsPerPage - numDeletedPerPage);

  if (allItemsSelected) {
    // Unselect all items currently on the page
    arrayOfValues.forEach(value => updatedLots.delete(value.lot));
  } else {
    // Select all items currently on the page
    arrayOfValues.forEach(value => !value.deleted && updatedLots.add(value.lot));
  }

  return updatedLots;
};

// Toggle a table row as selected or unselected
export const handleRowCheckbox = ({
  id,
  lotNumber,
  invNumber,
  arePublishedSelected
}, selectedLots) => {
  let updatedLots = [...selectedLots];
  if (updatedLots.some(lot => lot.id === id)) {
    updatedLots = updatedLots.filter(lot => lot.id !== id);
  } else {
    updatedLots = [...updatedLots, { id, lotNumber, invNumber, arePublishedSelected }];
  }
  return updatedLots;
};

/**
 *
 * @param {*} row
 * @param {*} selectedLots
 * @returns Set
 */
export const handleRowCheckboxWithSet = (row, selectedLots) => {
  const updatedLots = new Set(selectedLots);
  if (updatedLots.has(row)) {
    updatedLots.delete(row);
  } else {
    updatedLots.add(row);
  }
  return updatedLots;
};

// (bnikom) select/unselect checkboxes based on filter from dropdown
export const handleFilterCheckbox = (lots, selectedLots, type, clear) => {
  const updatedLots = new Set(selectedLots);

  // to select ALL items
  if (type === 'items') {
    if (clear) {
      // Unselect all NON-DELETED items
      lots.forEach(lot => updatedLots.delete(lot.lotID));
    } else {
      // Select all NON-DELETED items
      lots.forEach(lot => !lot.deleted && updatedLots.add(lot.lotID));
    }

    return updatedLots;
  }

  lots.forEach(lot => {
    if (clear) {
      (type === 'images' ? lot[type] <= 0 : lot[type]) && updatedLots.delete(lot.lotID);
    } else if (updatedLots.has(lot.lotID)) {
      /**
       * (bnikom) unselect lots that don't apply to filter (switching from filter to filter
       * without clearing OG filter)
       */
      (type === 'images' ? lot[type] > 0 : !lot[type]) && updatedLots.delete(lot.lotID);
    } else {
      // (bnikom) select lots that apply to filter
      (type === 'images' ? lot[type] <= 0 : lot[type]) && !lot.deleted && updatedLots.add(lot.lotID);
    }
  });

  return updatedLots;
};
